module.exports = "@media print {\n  body * {\n    visibility: hidden; }\n  #bloquePrint * {\n    visibility: visible; }\n  #bloquePrint {\n    position: absolute;\n    left: 0;\n    top: 0; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/consulta/documentos/detallejustificantes/detallejustificantes.component.scss
// module id = ./src/app/consulta/documentos/detallejustificantes/detallejustificantes.component.scss
// module chunks = main